import React from 'react'
import { Link } from 'react-router-dom'
import '../../style/Jumbotron.css'

class Jumbotron extends React.Component{
    render(){
        return(
            <div className = {this.props.bg}>
                <h1 > {this.props.h}</h1>
                <hr className="my-4"/>
                <h5>{this.props.p}</h5>
          </div>
        )
    }
}

export default Jumbotron